<template>
    <v-card>
        <v-card-title class="headline" v-html="message"/>
            <v-card-actions>
                <v-spacer/>
                <div class="btn-actions">
                    <v-btn @click="$emit('cancel')" color="primary darken-1" v-text="$t('no')"/>
                    <v-btn @click="$emit('accept')" color="red darken-1" v-text="$t('yes')"/>
                </div>
            </v-card-actions>
        </v-card>
</template>

<script>
export default {
  name: 'DeletePopup',
  props: { message: { type: String, default: 'Вы уверены, что хотите удалить?' } }
}
</script>
